import UserCurrencyConfig from '../../components/WalletConfig/UserCurrencyConfig';

export default function UserCurrencyConfigPage() {
	return <UserCurrencyConfig />;
}
